import OverviewMapV4 from "./OverviewMapV4";
import React from "react";
import * as Const from "../Const";


function TestMainUi(props) {


    return (
        <>
            <OverviewMapV4
                parcels={""}
                hiddenParcels={""}
                machines={""}
                livePositions={""}
                navigationSkills={""}
                selectedMachineName={""}
                selectedFieldName={""}
                parcelFilter={""}
                onParcelClicked={() => {}}
                onMachineClicked={(machineName) => {}}
                onMachinePopupClosed={(machineName) => {}}
                counter={0}
                updateCounter={0}
            >

                <>
                    <div className={"position-absolute top-0 start-0 bg-info"} style={{width: "16%", zIndex: Const.PANEL_OVERLAY_Z + 20}}>
                        Left
                    </div>
                    <div className={"position-absolute top-0 end-0 bg-info"} style={{width: "16%", zIndex: Const.PANEL_OVERLAY_Z + 20}}>
                        Right
                    </div>
                </>

            </OverviewMapV4>


        </>
    );

}


export default TestMainUi;